export default __webpack_public_path__ + "static/media/element_66.e66ab0dd.webp";